import { render, staticRenderFns } from "./ImageAndNumber.vue?vue&type=template&id=71e6f778&scoped=true&"
import script from "./ImageAndNumber.vue?vue&type=script&lang=js&"
export * from "./ImageAndNumber.vue?vue&type=script&lang=js&"
import style0 from "./ImageAndNumber.vue?vue&type=style&index=0&id=71e6f778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e6f778",
  null
  
)

export default component.exports